import React, { PropsWithChildren } from "react"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n"

import { useCustomerInfo } from "../../CustomerInfo"
import { Card, CardContent, CardHeader } from "../components/Card"
import { HeaderContent, HeaderLogo, HeaderWelcome, CornerLogo } from "../components/Logo"

export const PageContent = ({ children }: PropsWithChildren) => {

  const { i18n } = useTranslations()
  const { data } = useCustomerInfo()
  const hasSkin = !!data?.skin && data.skin !== "http://localhost:3003/cirrus-skins-dev/default/skin.css"

  return <Container className="container">
    <Card id="sfl-container">
      <CardHeader className="panel-heading">
        <HeaderContent className="logo-header-background">
          {
            !hasSkin && <>
              <CornerLogo />
              <HeaderLogo />
              <HeaderWelcome />
            </>
          }
        </HeaderContent>
      </CardHeader>

      <CardContent id="sfl-body">
        {children}
      </CardContent>
    </Card>

  </Container>
}

const Container = styled("div")(({ theme }) => ({
  gridColumn: 2,
  gridRow: 1,
  maxWidth: "54.4rem",
  width: "100%",

  [theme.breakpoints.down("md")]: {
    gridColumn: 1,
    order: 1,
  }
}))
